import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { rolesApi } from '../api/roles.api';
import { onClearDataSearch } from '../../../services/hookHelpers';
import { formatDataSearch } from '../../../services/helpers';
import { STATUS } from '../interfaces/roles.interface';
import  {useDataTable} from '../../../hooks/useDataTable';
export const useRoles = () => {
   const table = useDataTable(rolesApi);
   const {
     setDataFilters,
   } = table;
  useEffect(() => {
    setDataFilters([
      {
        filter: 'status',
        value_filter: '',
        data: STATUS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, []);
  return {
    ...table
  };
};
